import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorHandlingService } from '../services/error-handling.service';
import { ErrorData } from '../models/error-handling.model';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly errorHandling: ErrorHandlingService,
    private readonly router: Router,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const requestContext = this.router.url; // capture route at request time
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Only handle error statuses >= 400
        const statusCode = this.extractStatusCode(error);
        if (statusCode >= 400 || statusCode === 0) {
          const errorData: ErrorData = {
            statusCode,
            message: this.extractMessage(error),
            timestamp: new Date().toISOString(),
            endpoint: req.urlWithParams,
            method: req.method,
            requestData: req.body,
            type: 'HTTP',
            contextId: requestContext,
          };
          this.errorHandling.processError(errorData);
        }
        return throwError(() => error);
      }),
    );
  }

  private extractStatusCode(error: HttpErrorResponse): number {
    const fromPayload =
      error?.error && typeof error.error === 'object'
        ? (error.error.code as number)
        : undefined;
    return error.status || fromPayload || 0;
  }

  private extractMessage(error: HttpErrorResponse): string {
    if (error?.error) {
      if (typeof error.error === 'string') return error.error;
      if (typeof error.error === 'object' && 'message' in error.error) {
        return (error.error as any).message as string;
      }
    }
    return error.message || 'Unknown error';
  }
}
